const emojiRegexModule = require('emoji-regex');
const emojiRegex = emojiRegexModule.default || emojiRegexModule;

const toNumberLetter = (num) => {
    // 1 = A
    // 2 = B
    // 3 = C
    let letter = String.fromCharCode(num + 64);
    return letter;
}

/**
 * Remove all emojis from a string
 * @param {string} text - The input text
 * @returns {string} - Text with emojis removed
 */
const removeEmojis = (text) => {
    if (!text || typeof text !== 'string') {
        return '';
    }

    // Use emoji-regex package for comprehensive emoji detection
    const regex = emojiRegex();

    return text.replace(regex, '');  // Only remove emojis, preserve all whitespace
}

module.exports = {
    toNumberLetter,
    removeEmojis,
}